import { useLocation } from 'react-router-dom'

/** Changes each time the assistant's Review is clicked (AssistantProvider.openReview), even on the same URL. */
export const useReviewStamp = () => {
  const { state } = useLocation()
  return (state as { review?: number } | null)?.review ?? 0
}

/** Brings the review banner into view. */
export const scrollReviewIntoView = () => {
  window.setTimeout(() => {
    document.querySelector('[data-assistant-review]')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, 50)
}
